<template>
	<div class="rank" v-if="new_rankList">
	  <!-- 睡眠得分排行榜 -->
	  <div class="rankList" :style="{ boxShadow: isTip ? 'unset': '8px 8px 20px 0px #D1D9E6, -8px -8px 20px 0px #FFFFFF', pointerEvents: isTip ? 'none' : 'unset'}">
		<div class="rListTop">
		  <div class="rListTopTit">睡眠得分排行榜</div>
		  <!-- <div class="wenhaoIconWrap">
			<img class="wenhaoIcon" src="../../../assets/wenhaoIcon.png" alt="">
			<div class="whBubble">
			  <img class="home_pic_triangle_d" src="../../../assets/home_pic_triangle_d.png" alt="">
			  <div class="bubbleTit">睡眠得分反映的是使用者整晚睡眠的综合情况，分数越高，综合感受越好。</div>
			  <div class="bubbleTipWrap">
				<img class="bubbleTip_upImg" src="../../../assets/soIcon_up_green.png" alt="">
				<div class="bubbleTip ml5">上升代表有提升</div>
				<img class="bubbleTip_upImg" style="margin-left:28px;" src="../../../assets/soIcon_down_red.png" alt="">
				<div class="bubbleTip ml5">下降代表需要关注</div>
			  </div>
			</div>
		  </div> -->
		 
		  <div class="rListTopTit2">昨天</div>
		</div>
		<!-- 有数据情况 -->
		<div class="rListBot" v-if="data && data.sleepRankingList && data.sleepRankingList.length > 0">
		  <div class="rListBot_list rListBot_list_topBox">
			<div class="num">排名</div>
			<div class="bedName">床位</div>
			<div class="score">得分</div>
		  </div>
		  <div class="item1" :key="index" v-for="(item,index) in data.sleepRankingList" @click="details(item.bedId,item.bedName,item.sn, 'rankSleep')" style="position: relative;">
			<div class="rListBot_list" v-if="index < 8">
			  <div class="num">{{ item.ranking }}</div>
			  <div class="bedName">{{ item.bedName }}</div>
			  <div class="score">{{item.value}}</div>
			  <img class="soIcon" src="../../../assets/soIcon_up_green.png" alt="" v-if="item.trend == 1">
			  <img class="soIcon" src="../../../assets/soIcon_down_red.png" alt="" v-if="item.trend == -1">
			  <div class="soIcon_gang" v-if="item.trend == 0"></div>
			</div>
			<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 100000; top: -40px; padding: 10px; border-radius: 8px; display: none; left: 50%;">
				<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; color: rgba(94, 103, 121, 1);">{{ item.bedName || '' }}</div>
			</div>
		  </div>
		  
		</div>
		<!-- 无数据情况 -->
		<div class="rListBot noData" v-if="!data || !data.sleepRankingList || data.sleepRankingList.length == 0">
		  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
			<img v-if="(data && data.rankingListTips != '院长端未关联任何设备') || !data" style="width: 107px; height: 107px; margin-bottom: 15px;" src="../../../assets/icon_dean_home_card_empty_icon_2.png" alt="">
			<div v-if="(data && data.rankingListTips != '院长端未关联任何设备') || !data" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 20px;">睡眠设备赶紧用起来才能看到更多内容哦</div>
		  </div>
		</div>
	  </div>
	  <!-- 跌倒风险排行榜 -->
	  <div class="rankList" :style="{ boxShadow: isTip ? 'unset': '8px 8px 20px 0px #D1D9E6, -8px -8px 20px 0px #FFFFFF', pointerEvents: isTip ? 'none' : 'unset'}">
		<div class="rListTop">
		  <div class="rListTopTit">跌倒风险排行榜</div>
		  <div class="wenhaoIconWrap">
			<img class="wenhaoIcon" src="../../../assets/icon_dean_home_alert_icon_17.png" alt="">
			<div class="whBubble whBubble_dd">
			  <img class="home_pic_triangle_d" src="../../../assets/icon_common_special_arrow_6.png" alt="">
			  <div class="bubbleTit">跌倒风险反映的是使用者跌倒的可能性，分数越高，跌倒的风险越高（参考值≤50）</div>
			  <div style="background: rgba(176, 184, 200, 0.1); border-radius: 6px; padding: 10px 15px; display: flex; flex-direction: row; justify-content: flex-start; margin-top: 5px; ">
				<div style="width: 8px; height: 8px; background: #FF7186; border-radius: 4px; margin-top: 9px;"></div>
				<div style="flex: 1; margin-left: 5px; font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 24px;">当跌倒风险指数大于50的时候，建议您关注一下长者的情况</div>
			  </div>
			  <div class="bubbleTipWrap" style="background: rgba(176, 184, 200, 0.1); border-radius: 6px; padding: 10px 12px 10px 15px;">
				<img class="bubbleTip_upImg" src="../../../assets/soIcon_up_red.png" alt="">
				<div class="bubbleTip ml5">上升代表需要关注</div>
				<img class="bubbleTip_upImg" style="margin-left:28px;" src="../../../assets/soIcon_down_green.png" alt="">
				<div class="bubbleTip ml5">下降代表有好转</div>
			  </div>
			</div>
		  </div>
		  <div class="rListTopTit2">昨天</div>
		</div>
		<!-- 有数据情况 -->
		<div class="rListBot" v-if="data && data.fallRankingList && data.fallRankingList.length > 0">
		  <div class="rListBot_list rListBot_list_topBox">
			<div class="num">排名</div>
			<div class="bedName">床位</div>
			<div class="score">指数</div>
		  </div>
		  <div class="item1" :key="index" v-for="(item,index) in data.fallRankingList" @click="details(item.bedId,item.bedName,item.sn, 'rankFallDown')" style="position: relative;">
			<div class="rListBot_list" v-if="index < 8">
			  <div class="num">{{ item.ranking }}</div>
			  <div class="bedName">{{ item.bedName }}</div>
			  <div class="score color4D8EF7" style="width: 48px; color: rgba(61, 206, 173, 1) !important;" v-if="item.value < 50">{{item.value}}</div>
			  <div class="score colorFF7186" style="width: 48px;" v-if="item.value >= 50">{{item.value}}</div>
			  <img class="soIcon" src="../../../assets/soIcon_down_green.png" alt="" v-if="item.trend == -1">
			  <img class="soIcon" src="../../../assets/soIcon_up_red.png" alt="" v-if="item.trend == 1">
			  <div class="soIcon_gang" v-if="item.trend == 0"></div>
			</div>
			<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 100000; top: -40px; padding: 10px; border-radius: 8px; display: none; left: 50%;">
				<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; color: rgba(94, 103, 121, 1);">{{ item.bedName || '' }}</div>
			</div>
		  </div>
		</div>
		<!-- 无数据情况 -->
		<div class="rListBot noData" v-if="!data || !data.fallRankingList || data.fallRankingList.length == 0">
			<div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
				<img v-if="(data && data.rankingListTips != '院长端未关联任何设备') || !data" style="width: 107px; height: 107px; margin-bottom: 15px;" src="../../../assets/icon_dean_home_card_empty_icon_2.png" alt="">
				<div v-if="(data && data.rankingListTips != '院长端未关联任何设备') || !data" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 20px;">{{data && data.rankingListTips ? data.rankingListTips : '睡眠设备赶紧用起来才能看到更多内容哦'}}</div>
		  	</div>
		</div>
	  </div>
	  <!-- 呼吸异常指数排行榜 -->
	  <div class="rankList" :style="{ boxShadow: isTip ? 'unset': '8px 8px 20px 0px #D1D9E6, -8px -8px 20px 0px #FFFFFF', pointerEvents: isTip ? 'none' : 'unset'}">
		<div class="rListTop">
		  <div class="rListTopTit">呼吸异常指数排行榜</div>
		  <div class="wenhaoIconWrap">
			<img class="wenhaoIcon" src="../../../assets/icon_dean_home_alert_icon_17.png" alt="">
			<div class="whBubble whBubble_hxyc">
			  <img class="home_pic_triangle_d" src="../../../assets/icon_common_special_arrow_6.png" alt="">
			  <div class="bubbleTit">呼吸异常风险反映的是使用者呼吸潜在的异常风险</div>
			  <div style="background: rgba(176, 184, 200, 0.1); border-radius: 6px; padding: 10px 12px 10px 15px; margin-top: 5px;">
				<div class="bubbleTipWrap">
					<div class="buPoint bgFF7186"></div>
					<div class="bubbleTip ml5">{{'指数≥30 疑似高风险'}}</div>
				</div>
				<div class="bubbleTipWrap">
					<div class="buPoint bgFFC471"></div>
					<div class="bubbleTip ml5">{{'15≤指数<30 疑似中风险'}}</div>
				</div>
				<div class="bubbleTipWrap">
					<div class="buPoint bgFFC471"></div>
					<div class="bubbleTip ml5">{{'5≤指数<15 疑似低风险'}}</div>
				</div>
				<div class="bubbleTipWrap">
					<div class="buPoint" style="background: rgba(68, 215, 182, 1);"></div>
					<div class="bubbleTip ml5">{{'指数<5 是健康'}}</div>
				</div>
			  </div>
			  <div class="bubbleTipWrap" style="background: rgba(176, 184, 200, 0.1); border-radius: 6px; padding: 10px 12px 10px 15px;">
				<img class="bubbleTip_upImg" src="../../../assets/soIcon_up_red.png" alt="">
				<div class="bubbleTip ml5">上升代表需要关注</div>
				<img class="bubbleTip_upImg" style="margin-left:28px;" src="../../../assets/soIcon_down_green.png" alt="">
				<div class="bubbleTip ml5">下降代表有好转</div>
			  </div>
			</div>
		  </div>
		  <div class="rListTopTit2">昨天</div>
		</div>
		<!-- 有数据情况 -->
		<div class="rListBot" v-if="data && data.ahiRankingList && data.ahiRankingList.length > 0">
		  <div class="rListBot_list rListBot_list_topBox">
			<div class="num">排名</div>
			<div class="bedName" style="width: 185px;">床位</div>
			<div class="score" style="width: 48px;">指数</div>
		  </div>
		  <div class="item1" :key="index" v-for="(item,index) in data.ahiRankingList" @click="details(item.bedId,item.bedName,item.sn, 'rankBreathe')" style="position: relative;">
			<div class="rListBot_list" v-if="index < 8">
			  <div class="num">{{ item.ranking }}</div>
			  <div class="bedName" style="width: 185px;">{{ item.bedName }}</div>
			  <div class="score color4D8EF7" style="width: 48px; color: rgba(61, 206, 173, 1) !important;" v-if="item.value < 5">{{item.value}}</div>
			  <div class="score colorFFC471" style="width: 48px;" v-if="item.value >= 5 && item.value <= 30">{{item.value}}</div>
			  <div class="score colorFF7186" style="width: 48px;" v-if="item.value > 30">{{item.value}}</div>
			  <img class="soIcon" src="../../../assets/soIcon_down_green.png" alt="" v-if="item.trend == -1">
			  <img class="soIcon" src="../../../assets/soIcon_up_red.png" alt="" v-if="item.trend == 1">
			  <div class="soIcon_gang" v-if="item.trend == 0"></div>
			</div>
			<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 100000; top: -40px; padding: 10px; border-radius: 8px; display: none; left: 50%;">
				<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; color: rgba(94, 103, 121, 1);">{{ item.bedName || '' }}</div>
			</div>
		  </div>
		  
		</div>
		<!-- 无数据情况 -->
		<div class="rListBot noData" v-if="!data || !data.ahiRankingList || data.ahiRankingList.length == 0">
			<div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
				<img v-if="(data && data.rankingListTips != '院长端未关联任何设备') || !data" style="width: 107px; height: 107px; margin-bottom: 15px;" src="../../../assets/icon_dean_home_card_empty_icon_2.png" alt="">
				<div v-if="(data && data.rankingListTips != '院长端未关联任何设备') || !data" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 20px;">睡眠设备赶紧用起来才能看到更多内容哦</div>
			</div>
		</div>
	  </div>

	  <div v-if="isTip" style="position: absolute; top: -260px; left: 336px; display: flex; flex-direction: column; align-items: center;">
			<div style="width: 529px; background: #5E6779; border-radius: 8px; padding-left: 20px; padding-right: 20px; padding-top: 20px; padding-bottom: 15px">
				<div style="background: rgba(255, 255, 255, 0.1); border-radius: 6px; padding-left: 15px; padding-right: 15px; padding-top: 10px; padding-bottom: 10px; position: relative;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF00; line-height: 24px; width: 100%; white-space: wrap;">
						·睡眠得分排行榜：可以查看健康状态相对较好的老人；
					</div>
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF00; line-height: 24px; width: 100%; white-space: wrap; margin-top: 5px;">
						·跌倒风险排行榜：指数反映老人跌倒的可能性，分数越高，跌倒的风险越高；
					</div>
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF00; line-height: 24px; width: 100%; white-space: wrap; margin-top: 5px">
						·呼吸异常指数排行榜：指数反映老人呼吸潜在的异常风险，分数越高，呼吸异常风险越高；
					</div>
					<div style="position: absolute; height: 8px; background: rgba(88, 188, 255, 0.3); left: 215px; top: 25px; width: 128px; height: 8px;"></div>
					<div style="position: absolute; height: 8px; background: rgba(88, 188, 255, 0.3); left: 248px; top: 54px; width: 95px; height: 8px;"></div>
					<div style="position: absolute; height: 8px; background: rgba(88, 188, 255, 0.3); left: 280px; top: 107px; width: 143px; height: 8px;"></div>
					<div style="position: absolute; font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF; line-height: 24px; left: 15px; top: 10px; right: 15px;">
						·睡眠得分排行榜：可以查看健康状态相对较好的老人；
					</div>
					<div style="position: absolute; font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF; line-height: 24px; left: 15px; top: 39px; right: 15px;">
						·跌倒风险排行榜：指数反映老人跌倒的可能性，分数越高，跌倒的风险越高；
					</div>
					<div style="position: absolute; font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF; line-height: 24px; left: 15px; top: 92px; right: 15px;">
						·呼吸异常指数排行榜：指数反映老人呼吸潜在的异常风险，分数越高，呼吸异常风险越高；
					</div>
				</div>
				<div style="margin-top: 15px; display: flex; justify-content: space-between; align-items: center;">
					<div style="display: flex;">
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 14px; color: rgba(255, 255, 255, 0.5); line-height: 24px;">3/3</div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 14px; color: rgba(255, 255, 255, 0.5); line-height: 24px; margin-left: 15px; cursor: pointer;" @click="skippingTutorial">再看一遍</div>
					</div>
					<div style="display: flex; align-items: center;">
						<div style="display: flex; align-items: center; margin-right: 20px; cursor: pointer" @click="notTipClick">
							<img v-if="selectNotTip" style="width: 16px; height: 16px; margin-right: 5px;" src="../../../assets/icon_home_tip_success_1.png" alt="">
							<img v-if="!selectNotTip" style="width: 16px; height: 16px; margin-right: 5px;" src="../../../assets/icon_home_tip_error_1.png" alt="">
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #FFFFFF; line-height: 20px;">不再提示</div>
						</div>
						<div style="width: 86px; height: 30px; background: #4A7CE8; border-radius: 20px; font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #FFFFFF; line-height: 20px; display: flex; align-items: center; justify-content: center; cursor: pointer;" @click="next">我知道了</div>
					</div>
				</div>
			</div>
			<img style="width: 38px; height: 12px;" src="../../../assets/icon_home_hei_san_jiao_2.png" alt="" />
		</div>

	</div>
  </template>
  
  <script>
  export default {
	props: {
	  healthBigData: null,
	  data: null,
	  isTip: {
		type: Boolean,
		default: false
	  }
	},
	watch: {
	  data(newVal,oldVal){
		this.new_rankList = newVal
	  }
	},
	data() {
	  return {
		new_rankList: [],
		//rankData[rankList[item-1]][index]
		rankEmpty: false,
		rankData: {},
		titleList: [
		  '睡眠得分排行榜',
		  'AHI排行榜',
		  '跌倒风险指数排行榜',
		  '活力值排行榜',
		  '情绪值排行榜',
		],
		rankList: ['sleepTop', 'ahiTop', 'fallTop', 'vitalityTop', 'moraleTop'],
		scoreList: ['score', 'ahi', 'fallIndex', 'vitalityIndex', 'moraleIndex'],
		maxHeight: {},
		resultReasons: [false, false],
		getHours: null,
		timeStatus: false,
		activeDates: [],
		selectNotTip: false
	  };
	},
	created() {},
	mounted() {
	  this.getActiveDates();
	},
	methods: {
	  getActiveDates() {
		var day = new Date();
		var time = day.getTime();
		for (var i = 0; i <= 29; i++) {
		  var ms = 24 * 3600 * 1000 * i;
		  day.setTime(parseInt(time - ms));
		  var y = day.getFullYear().toString();
		  var m = (day.getMonth() + 1).toString();
		  if (m.length <= 1) m = '0' + m;
		  var d = day.getDate().toString();
		  if (d.length <= 1) d = '0' + d;
		  this.activeDates[i] = y + '-' + m + '-' + d;
		}
	  },
	  details(bedId, bedName, sn, pageName) {
		var scope = {
		  bedId: bedId,
		  bedName: bedName,
		  activeType: 1,
		  activeDate: this.activeDates[0],
		  sn: sn,
		};
		this.$parent.details(scope, pageName);
	  },
	  // 再看一遍
		skippingTutorial() {
			this.$emit('skippingTutorial', 3);
		},
		// 我知道了
		next() {
			this.$emit('next', 3, this.selectNotTip);
		},
		// 不再提示
		notTipClick() {
			this.selectNotTip = !this.selectNotTip;
		}
	},
  };
  </script>
  <style lang="scss" scoped>
  .rank {
	position: relative;
	width: 100%;
	margin-top: 0px;
	display: flex;
	justify-content: space-between;
	.rankList:nth-of-type(1){
	  margin-left: 0;
	}
	.rankList{
	  width: 380px;
	  height: 452px;
	  background: #ECF0F3;
	  box-shadow: 8px 8px 20px 0px #D1D9E6, -8px -8px 20px 0px #FFFFFF;
	  border-radius: 20px;
	  padding: 20px;
	  box-sizing: border-box;
	  margin-left: 10px;
	  .rListTop{
		width: 100%;
		display: flex;
		align-items: center;
		.rListTopTit{
		  font-size: 18px;
		  font-family: PingFangSC-Medium, PingFang SC;
		  font-weight: 500;
		  color: #1F2635;
		  position:relative
		}
		.rListTopTit::after{
		  width: 4px;
		  height: 20px;
		  background: #1890FF;
		  border-radius: 0px 2px 2px 0px;
		  content: '';
		  position: absolute;
		  left: -20px;
		  top: 3px;
		}
		.wenhaoIconWrap:hover .whBubble{
		  display: block;
		}
		.wenhaoIconWrap{
		  width: 20px;
		  height: 20px;
		  margin-left: 5px;
		  cursor: pointer;
		  position: relative;
		  .wenhaoIcon{
			width: 100%;
			height: 100%;
			display: block;
		  }
		  .whBubble{
			width: 375px;
			height: 128px;
			background: #FFFFFF;
			// box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.2);
			border-radius: 8px;
			padding: 20px;
			box-sizing: border-box;
  
			position: absolute;
			top: -140px;
			left: -178px;
			z-index: 999;
			display: none;
			.home_pic_triangle_d{
			  width: 38px;
			  height: 16px;
			  display: block;
			  position: absolute;
			  left: 50%;
			  bottom: -16px;
			  transform: translateX(-50%);
			}
		  
			.bubbleTit{
			  width: 335px;
			  font-size: 16px;
			  font-family: PingFangSC, PingFang SC;
			  font-weight: 400;
			  color: #5E6779;
			  line-height: 24px;
			  position: relative;
			}
			.bubbleTit::after{
			//   width: 3px;
			//   height: 18px;
			//   content: '';
			//   background: #4D8EF7;
			//   border-radius: 2px;
			  
			//   position: absolute; 
			//   left: -20px; 
			//   top: 3px; 
			}
			.bubbleTipWrap{
			  margin-top: 2px;
			  display: flex;
			  align-items: center;
			  .bubbleTip_upImg{
				width: 9px;
				height: 12px;
				display: block;
			  }
			  .bubbleTip{
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #5E6779;
			  }
			  .buPoint{
				width: 8px;
				height: 8px;
				background: #4D8EF7;
				border-radius: 50%;
			  }
			}
		  }
		  .whBubble_dd{
			height: 207px;
			top: -227px;
		  }
		  .whBubble_hxyc{
			height: 264px;
			top: -286px;
		  }
  
		}
		.rListTopTit2{
		  font-size: 14px;
		  font-family: PingFangSC-Medium, PingFang SC;
		  font-weight: 500;
		  color: rgba(94, 103, 121, 0.5);
		  margin-left: auto;
		}
	  }
	  .rListBot{
		width: 342px;
		height: 378px;
		margin-top: 10px;
		background: rgba(255,255,255,0.7);
		border-radius: 16px;
		border: 1px solid #FFFFFF;
		// backdrop-filter: blur(8px);
		.rListBot_list{
		  height: 40px;
		  border-top: 1px solid #ECEDF0;
		  display: flex;
		  align-items: center;
		  margin-left: 20px;
		  margin-right: 20px;
		  cursor: pointer;
		  .num{
			width: 48px;
		  }
		  .bedName{
			width: 195px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		  }
		  .score{
			width: 38px;
			margin-left: 10px;
		  }
		  .soIcon{
			width: 9px;
			height: 12px;
		  }
		  .soIcon_gang{
			width: 9px;
			height: 2px;
			background: #CACDD9;
		  }
		}
		.rListBot_list_topBox{
		  height: 50px;
		  border-top: 0;
		  div{
			font-weight: bold;
		  }
		}
	  }
	  .noData{
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #A5A9BC;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ECF0F3;
		box-shadow: inset 8px 8px 20px 0px #D1D9E6, inset -8px -8px 20px 0px #FFFFFF;
		border-radius: 16px;
		border: 1px solid #FFFFFF00;
	  }
	}
  }
  .item1 {
	background: #FFFFFF00;
  }
  .item1:hover {
	background: rgba(74, 124, 232, 0.05);
	.bedName {
		color: rgba(74, 124, 232, 1);
	}
	.showDescription {
		display: block !important;
	}
  }
  </style>
  